<template>
    <div class="pt-3 pb-5">
        <div class="row">
            <div class="col-12 mb-5">
                <label>Załaduj grafikę</label>
                <vue-dropzone
                    ref="VueDropzone"
                    id="dropzone"
                    :options="dropzoneOptions"
                    @vdropzone-queue-complete="queuecomplete"
                ></vue-dropzone>
            </div>
            <div class="row m-0 w-100">
                <div class="col-12">
                    <h3 class="text-center font-weight-bold">Galeria zdjęć</h3>
                    <hr>

                    <p v-if="!data || data.length == 0">Brak zdjęć</p>
                </div>
                <div class="col-xl-2 col-lg-4 col-sm-6 text-center" v-for="(item, key) in data" :key="key">
                    <div class="position-relative shadow gallery-single">
                        <img :src="item.url" class="mw-100 mh-100 img-thumbnail o-fit" style="height:180px">

                        <div class="gallery-action position-absolute">
                            <button @click.prevent="removeImage(item.id)" class="btn btn-danger rounded-circle p-2"><iconRemove /></button>
                        </div>
                    </div>
                    <p>{{item.name}}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import InputFile from '../../ui/InputFile';
    import SunEditor from '../../ui/SunEditor';
    import iconRemove from '../../icon/remove';

    export default {
        data() {
            return {
                token: this.$parent._props.api_token,
                data: null,

                dropzoneOptions:
                {
                    url: '/gallery/save?api_token=' + this.$parent._props.api_token,
                    headers: {
                        'x-csrf-token': this.$parent._props.csrf,
                    },
                    paramName: "file",
                    maxFilesize: 2,
                    acceptedFiles: 'image/*',
                    dictCancelUpload: "Przesyłanie anulowane.",
                    dictCancelUploadConfirmation: "Jesteś pewny że chcesz przerwać ładowanie?",
                    dictDefaultMessage: "Upuść pliki tutaj, aby przesłać",
                    dictFallbackMessage: "Twoja przeglądarka nie obsługuje przesyłania plików metodą drag'n'drop.",
                    dictFallbackText: "Skorzystaj z poniższego formularza rezerwowego, aby przesłać pliki tak, jak za dawnych czasów.",
                    dictFileTooBig: "Plik jest za duży ({{filesize}} MiB). Maksymalny rozmiar pliku: {{maxFilesize}} MiB.",
                    dictInvalidFileType: "Nie możesz przesyłać plików tego typu.",
                    dictMaxFilesExceeded: "Nie możesz przesłać więcej plików.",
                    dictRemoveFile: "Usuń plik.",
                    dictResponseError: "Serwer odpowiedział kodem {{statusCode}}.",
                    dictUploadCanceled: "Przesyłanie anulowane.",
                }
            }
        },
        components: {
            InputFile, SunEditor, iconRemove
        },
        mounted(){
            axios.defaults.params = {};
            axios.defaults.params['api_token'] = this.token;

            let _this = this;
            this.$parent._data.loading = true;
            this.fetchData();
        },
        methods: {

            removeImage(id){
                axios
                .post('/gallery/remove/' + id).then(response => {

                    this.data = response.data.data;

                    this.$parent._data.message.success = response.data.success;
                    this.$parent._data.message.content = response.data.content;
                })
            },
            fetchData() {
                let _this = this;

                axios
                .get('/api/get-data', {
                    params:
                    {
                        'option': 'gallery',
                    }
                }).then(response => {
                    this.data = response.data;

                    $('.loading').animate({
                        opacity: 0,
                    }, 1000, function(){
                        _this.$parent._data.loading = false;
                    })
                })
            },
            queuecomplete: function(el){
                this.fetchData();
                let drop = this;

                setTimeout(function(){
                    drop.$refs.VueDropzone.removeAllFiles();
                }, 3000)
            }
        }
    }
</script>
